// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6e6b2b2c","453":"05cadb83","455":"4c562975"}[chunkId] + ".chunk.js";
};